import actionTypes from "./actionTypes";
import initialState from "./initialState";

const sidebarReducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.SIDEBAR :{ 
            return{
            ...state,
            sidebar:!state.sidebar
        }}
        default:{
            return state;
        }
    }
}

export default sidebarReducer;